export default __webpack_public_path__ + "444998cd.png";